export default "__VITE_ASSET__BqqBfM5$__"